import { Attachment, IAttachment } from '../../../components/attachment-upload-btn/attachment';

export interface IResume {
  text?: string;
  attachment?: IAttachment[];
}

export class Resume implements IResume {
  text: string;
  attachment: Attachment[];

  constructor( resume: IResume = {} ) {
    this.text = resume.text;
    this.attachment = (resume.attachment || []).map(( item ) => new Attachment(item));

  }
}



// WEBPACK FOOTER //
// ./app/core/entities/cv/resume.ts